/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RawImport {
    getFixupPrototypeFunction() { return RawImport.fixupPrototype; }

    static newInstance(model: Partial<RawImport>): RawImport {
        let obj = Object.assign(new RawImport(), model);
        RawImport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RawImport>): RawImport {
        if (!model) return null;
        return RawImport.newInstance(<RawImport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RawImport) {
        if (!obj) return;

        models.RawImport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RawImport): boolean {
        Object.setPrototypeOf(obj, RawImport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    contentsAsJSON: string;

}
